import { useEffect, useState } from 'react';
import { fetchAPI } from '../../utils/utils';
import SubvencionsGrantDetail from './SubvencionsGrantDetail';
import {
    getManualGrantGuideAsset,
    loadManualGrantGuide,
    mergeManualGrantGuide,
} from './manualGrantDetails';

function LoadingState() {
    return (
        <div style={{ textAlign: 'center', padding: 60, color: '#888' }}>
            <div style={{
                width: 32,
                height: 32,
                border: '3px solid #e0e0e0',
                borderTopColor: '#1976d2',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
                margin: '0 auto 12px',
            }} />
            Carregant subvenció...
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}

function ErrorState({ error }) {
    return (
        <div style={{
            textAlign: 'center',
            padding: 40,
            color: '#d32f2f',
            backgroundColor: '#fce4ec',
            borderRadius: 8,
        }}>
            {error}
        </div>
    );
}

function SubvencionsGrantDetailPage({ slug, year }) {
    const [grantDetail, setGrantDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const hasTimelessGuide = Boolean(getManualGrantGuideAsset(slug));

    useEffect(() => {
        let isCancelled = false;

        setLoading(true);
        setError(null);
        setGrantDetail(null);

        const manualGuideResult = hasTimelessGuide
            ? loadManualGrantGuide(slug).then(
                definition => ({ definition, loadError: null }),
                loadError => ({ definition: null, loadError })
            )
            : Promise.resolve({ definition: null, loadError: null });

        const endpoint = year && !hasTimelessGuide
            ? `/subvencions/cultura/${slug}/${year}`
            : `/subvencions/cultura/${slug}`;

        fetchAPI(endpoint, (data) => {
            if (isCancelled) return;

            if (data && data.error) {
                setError(data.error);
                setGrantDetail(null);
                setLoading(false);
                return;
            }

            manualGuideResult.then(({ definition, loadError }) => {
                if (isCancelled) return;

                if (loadError) {
                    setError(loadError.message || "No s'ha pogut carregar la guia.");
                    setGrantDetail(null);
                } else {
                    setGrantDetail(mergeManualGrantGuide(data, definition));
                }
                setLoading(false);
            });
        }, false);

        return () => {
            isCancelled = true;
        };
    }, [hasTimelessGuide, slug, year]);

    if (loading) {
        return <LoadingState />;
    }

    if (error) {
        return <ErrorState error={error} />;
    }

    if (!grantDetail) {
        return <ErrorState error="No s'ha pogut carregar la subvenció." />;
    }

    return (
        <SubvencionsGrantDetail
            data={grantDetail}
            requestedYear={hasTimelessGuide ? null : year}
        />
    );
}

export default SubvencionsGrantDetailPage;
